import * as Joi from 'joi';
import { Moment } from 'moment';
import { Column, Entity, OneToMany, PrimaryGeneratedColumn } from 'typeorm';
import { GenPartial, momentTransformer } from 'typeormgen';
import { INT_EXT } from '../enums/enums';
import { displayIntExt } from '../enums/enums.utils';
import EpisodicBase from '../episodic-base.entity';
import Scene from '../scenes/scene.entity';

@Entity('script_locations')
export default class ScriptLocation extends EpisodicBase {
	static tableName = 'script_locations';

	static skipUpdateColumns = [
		'id',
		'episodic_id',
		'created_by',
		'last_updated_user',
		'date_created',
		'last_updated_time',
	];

	@PrimaryGeneratedColumn()
	id: number;

	@Column('int')
	episodic_id: number;

	@Column('int')
	actual_location_id: number;

	@Column('int')
	int_ext: number;

	@Column('varchar')
	name: string;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	last_updated_time: Moment;

	@Column('int')
	last_updated_user: number;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	date_created: Moment;

	@Column('int')
	created_by: number;

	@OneToMany((type) => Scene, (scene) => scene.location)
	scenes: Scene[];

	static rules() {
		return {
			...super.rules(),
			actual_location_id: Joi.number().integer().allow(null),
			date_created: Joi.date().allow(null),
			int_ext: Joi.number().integer().allow(null),
			last_updated_time: Joi.date().allow(null),
			name: Joi.string().trim().max(1000).allow(null, ''),
			scenes: Joi.array().items().allow(null),
		};
	}

	getSetting(): string {
		switch (this.int_ext) {
			case INT_EXT.INT: {
				return 'INT';
			}
			case INT_EXT.EXT: {
				return 'EXT';
			}
			case INT_EXT.INT_EXT: {
				return 'INT/EXT';
			}
			case INT_EXT.EXT_INT: {
				return 'EXT/INT';
			}
			default: {
				return null;
			}
		}
	}

	toJSON() {
		return {
			...super.toJSON(),
			actual_location_id: this.actual_location_id,
			date_created: this.date_created,
			int_ext: this.int_ext,
			last_updated_time: this.last_updated_time,
			name: this.name,
			scenes: this.scenes ? this.scenes : [],
		};
	}

	assign(props?: GenPartial<ScriptLocation>) {
		super.assign(props);

		if (props) {
			if (typeof props.last_updated_time !== 'undefined') {
				this.last_updated_time = momentTransformer.from(
					props.last_updated_time
				);
			}
			if (typeof props.date_created !== 'undefined') {
				this.date_created = momentTransformer.from(props.date_created);
			}
		}
	}

	constructor(props?: GenPartial<ScriptLocation>) {
		super(props);
	}

	getFullName(): string {
		let name = '';
		if (this.int_ext) {
			name += `${displayIntExt(this.int_ext)}. `;
		}
		return `${name}${this.name ? this.name : ''}`;
	}
}
